<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Заказ №{{this.$router.currentRoute.params.id}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col md="4">
                  <strong>ФИО клиента:</strong>
                </v-col>
                <v-col md="4">{{order.clientFIO}}</v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <strong>Номер телефона:</strong>
                </v-col>
                <v-col md="4">{{order.clientPhone}}</v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <strong>Дата оформления заказа:</strong>
                </v-col>
                <v-col md="4">{{order.date}}</v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <strong>Комментарий:</strong>
                </v-col>
                <v-col md="4">{{order.comment}}</v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <strong>Подверждение:</strong>
                </v-col>
                <v-col md="4" v-if="order.isPodtv">Заявка подтверждена</v-col>
                <v-col md="4" v-else @click.prevent="Podtv()">
                  <v-btn class="success">Подтвердить</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <strong>Готовность:</strong>
                </v-col>
                <v-col md="4" v-if="order.isGotovo">Заявка готова к отправке</v-col>
                <v-col md="4" v-else @click.prevent="Gotovo()">
                  <v-btn class="error">Подтвердить готовность</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import axios from "axios";
import orderService from "../api-services/order.service";
export default {
  data() {
    return {
      order: {},
    };
  },
  methods: {
    async Podtv() {
      this.order.IsPodtv = true;
      location.reload();
      orderService.update(`${this.$router.currentRoute.params.id}`, this.order);
    },
    async Gotovo() {
      if (this.order.IsPodtv === false) {
        return alert("Заказ не был подтвержден!");
      }
      this.order.IsGotovo = true;
       location.reload();
      orderService.update(`${this.$router.currentRoute.params.id}`, this.order);
     
    },
  },
  mounted() {
    orderService.get(this.$router.currentRoute.params.id);
    /*axios
      .get(
        `https://practiqe.somee.com/api/order/${}`
      )
      .then((response) => {
        this.order = response.data;
        console.log(response);
      });*/
  },
};
</script>